export function formatCents(cents: number | null | undefined): string {
  return `$${((cents ?? 0) / 100).toFixed(2)}`
}

export function formatPct(value: number): string {
  return `${(value * 100).toFixed(1)}%`
}

export function formatTs(ts: number | null | undefined): string {
  if (!ts) return '--'
  return new Date(ts * 1000).toLocaleDateString()
}

export function referralStatusVariant(status: string) {
  switch (status) {
    case 'converted': return 'success' as const
    case 'trial':
    case 'pending': return 'warning' as const
    case 'churned':
    case 'fraudulent': return 'error' as const
    default: return 'default' as const
  }
}

export function rewardStatusVariant(status: string) {
  switch (status) {
    case 'credited':
    case 'paid': return 'success' as const
    case 'pending':
    case 'approved': return 'warning' as const
    case 'clawed_back':
    case 'voided': return 'error' as const
    default: return 'default' as const
  }
}

export function campaignStatusVariant(status: string) {
  switch (status) {
    case 'active': return 'success' as const
    case 'draft':
    case 'paused': return 'warning' as const
    case 'ended': return 'error' as const
    default: return 'default' as const
  }
}

export const TRIGGER_EVENTS = [
  'trial_signup',
  'paid_conversion',
  'retention_1m',
  'retention_2m',
  'retention_3m',
  'retention_6m',
  'retention_12m',
  'studio_creation',
] as const

export const REFERRER_REWARD_TYPES = [
  'credit',
  'free_months',
  'cash_flat',
  'cash_percent',
  'lesson_credit',
  'class_credit',
] as const

export const REFERRED_REWARD_TYPES = [
  'credit',
  'free_months',
  'trial_extension',
  'lesson_credit',
  'class_credit',
] as const
